module.exports = __webpack_public_path__ + "img/KRBS.c4a1ad8e.png";